import React, { useState, useEffect, useContext  } from 'react';
import { Routes, Route, Navigate, useNavigate, useParams } from 'react-router-dom';
import './FacilityUserMonitoredIndividualView.css';
import { EnvironmentContext } from '../../contexts/EnvironmentContext';
import baseApi from '../../common/api/base';
import MonitoredIndividualSummary from '../MonitoredIndividualSummary/MonitoredIndividualSummary';
import NotesHistory from '../NotesHistory/NotesHistory';
import CalendarDetails from '../CalendarDetails/CalendarDetails';
import PowerBiReport from '../PowerBiReport/PowerBiReport';
import logComponent from '../../common/logComponent';

export default function FacilityUserMonitoredIndividualView({ match }) {
  const environmentContext = useContext(EnvironmentContext);
  const { selectedMonitoredIndividual } = environmentContext;
  const [loadingSelectedMI, setLoadingSelectedMI] = useState(false);
  const navigate = useNavigate();
  const { monitoredIndividualId } = useParams();

  if (logComponent('FacilityUserMonitoredIndividualView')) { console.debug('FacilityUserMonitoredIndividualView rendered'); }

  useEffect(() => {
    if (logComponent('FacilityUserMonitoredIndividualView')) { console.debug('FacilityUserMonitoredIndividualView useEffect [environmentContext.selectedMonitoredIndividual, loadingSelectedMI, monitoredIndividualId]'); }

    if (!loadingSelectedMI &&
      (!selectedMonitoredIndividual ||
        selectedMonitoredIndividual.monitoredIndividualId != monitoredIndividualId)) {
      loadRoutedMonitoredIndividual();
    } 

  }, [environmentContext.selectedMonitoredIndividual, loadingSelectedMI, monitoredIndividualId]);


  const loadRoutedMonitoredIndividual = () => {
    if (logComponent('FacilityUserMonitoredIndividualView')) { console.debug('FacilityUserMonitoredIndividualView loadRoutedMonitoredIndividual'); }
    const { hasToken } = environmentContext;
    if (!hasToken) return;

    const { setSelectedMonitoredIndividual } = environmentContext;

    // Check for obviously bad params to avoid unnecessary api calls
    if (isNaN(monitoredIndividualId)) {
      navigate('/', { replace: true });
      return;
    }
    setLoadingSelectedMI(true);

    baseApi.MonitoredIndividual.Id(monitoredIndividualId, true)
      .then(
        result => {
          setSelectedMonitoredIndividual(result.data);
          setLoadingSelectedMI(false);
        },
        error => {
          setLoadingSelectedMI(false);
          navigate('/', { replace: true }); // TODO: Determine what we actually want to do in this case
        });
  }


  return (
    selectedMonitoredIndividual ?
      <div className="Facility-User-Monitored-Individual-View">
        <Routes>
            <Route path='/*' element={<MonitoredIndividualSummary />} />
            <Route path='/notes/*' element={<NotesHistory />} />
            <Route path='/calendar/*' element={<CalendarDetails />} />
            <Route path='/reports/:reportId' element={<PowerBiReport />} />
        </Routes>
      </div> :
      null
  );
}